// "sk-ant-", "sk-proj-", "gsk_", "xai-" — the part of a key that names its
// provider and type, never the secret itself.
const PREFIX = /^[A-Za-z]+[-_](?:[A-Za-z0-9]+[-_])?/

/** A key reduced to its prefix and last four characters: "sk-ant-…1234". */
export function maskKey(key) {
  const value = String(key ?? '').trim()
  const head = (value.match(PREFIX)?.[0] ?? value.slice(0, 2)).slice(0, 8)
  return `${head}…${value.slice(-4)}`
}
